import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import Calculator from 'app/theme/calculator'

import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'

import birthdayPartyGrid1 from 'assets/img/birthday-party-grid-1.jpg'
import birthdayPartyGrid2 from 'assets/img/birthday-party-grid-2.jpg'
import birthdayPartyGrid3 from 'assets/img/birthday-party-grid-3.jpg'
import birthdayPartyGrid4 from 'assets/img/birthday-party-grid-4.jpg'
import birthdayPartyBanner from 'assets/img/birthday-party-banner.jpg'

import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

import getGoogleMetaTags from './occasionSEOData'

export default function BirthdayCateringPage() {
  const { openModal, ...modalState } = useModalState()
  
  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  const googleMetaTags = getGoogleMetaTags('birthday')
  
  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Birthday Party Catering - Roaming Hunger</title>
        <meta name="description" content="Book the best birthday party catering near you. Need catering for a kids birthday party? Or 40th birthday party? We'll help you cater for any birthday milestone"></meta>
        <meta name="og:title" content="Birthday Party Catering"></meta>
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={birthdayPartyBanner}
          title="Birthday Party Catering"
          onButtonClick={openModal}
          description="We have relationships with over 16,000 caterers nationwide, including restaurants, pop-ups, and mobile caterers. Whether it's a 1st Birthday, Dirty 30, or Milestone, we can help you find the perfect birthday party caterer for your friends and family."
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <OccasionPageGrid>
        <OccasionPageGridRow
          heading="The Early Years"
          content="Pair your Marvel themed birthday party with all the finger foods that heroes and villains love. Need options for parents, friends, and family? Our caterers serve them too, in Hulk-sized portions."
          image={birthdayPartyGrid1}
        />
        <OccasionPageGridRow
          heading="Sweetest-Sixteen"
          content="Does your teenager have a big appetite? Start the bash with an all-you-can-eat taco bar. Sweeten the night with icream sandwiches or custom cupcakes."
          image={birthdayPartyGrid2}
          reverse
        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <OccasionPageGrid>
        <OccasionPageGridRow
          heading="The Dirty 30"
          content="End your roaring 20's with 30th birthday party catering that screams classy. Wait staff serving tuna tartare will make a great impression. Not your style? We'll bring out a mobile BBQ caterer for your casual, backyard hangout."
          image={birthdayPartyGrid3}
          reverse
        />
        <OccasionPageGridRow
          heading="Birthday party catering for every decade"
          content="One year older, one year wiser, and celebrating like you just turned 18. Whether it's your 40th, 50th, or 60th, our milestone birthday party caterers will make sure everyone goes home satisfied."
          image={birthdayPartyGrid4}
        />
      </OccasionPageGrid>
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorks heading="How Birthday Party Catering Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Birthday Party Catering Works" onButtonClick={openModal} />
      <FeaturedClients onButtonClick={openModal} />
      <Calculator
        heading="How Much Does Birthday Party Catering Cost?"
        onButtonClick={openModal}
      />
      <OccasionsSlider className="bg-white py-12" heading="Other catering occasions" onButtonClick={openModal} />
    </Layout>
  )
}
